import styled from "@emotion/styled";
import { GetPageQuery } from "apollo";
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper";
import {  ImageContainer, extractProperty } from "ui";
import { getNonUmbracoURL } from "utils/utils";

const StyledWrapper = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 60px;
    padding-bottom: 60px;
  }
`

type Props = {
    data: GetPageQuery
}
export const ImageBlockChrage: React.FC<Props> = ({ data }: Props) => {
    const imageDesktop = extractProperty(data, "imageDesktop")
    const imageMobile = extractProperty(data, "imageMobile")

    return (
        <ContainerWrapper withoutPadding>
            <StyledWrapper>
                <ImageContainer
                    desktopUrl={getNonUmbracoURL(imageDesktop)}
                    mobileUrl={getNonUmbracoURL(imageMobile)}
                    height={622}
                    mediumHeight={450}
                    mobileHeight={258}
                />
            </StyledWrapper>
        </ContainerWrapper>
    );
}

export default ImageBlockChrage;
